import { render, staticRenderFns } from "./FormSetor.vue?vue&type=template&id=4b17e5fb"
import script from "./FormSetor.vue?vue&type=script&lang=js"
export * from "./FormSetor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports